var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentDeadline)?_c('DeadlineRequirements',{attrs:{"current-deadline":_vm.currentDeadline,"missing-bank-account":_vm.onlyRequiresBankAccount}}):_c('NonDeadlineRequirements',{attrs:{"currently-due":_vm.currentlyDue,"eventually-due":_vm.eventuallyDue,"past-due":_vm.pastDue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }